export default {
  isTransactionSuccess: (state) => state.isSucceeded,

  getAccountRoles: (state) => (userId) => {
    let roles =
      state.accountList.data.data.find((element) => element.id == userId)
        ?.roles || [];
    return roles.map((obj) => obj.id);
  },

  getAccountFields: (state) => (userId) => {
    return (
      state.accountList.data.data.find((element) => element.id == userId)
        ?.userFields || []
    );
  },

  getAccountPermissionIds: (state) => (userId) => {
    let permissions =
      state.accountList.data.data.find((element) => element.id == userId)
        ?.permissions || [];
    return permissions.map((obj) => obj.id);
  },

  getPlainPassword: (state) => () => {
    return state.passwordResponse?.data || "";
  },
};
